<template>
  <div v-if="tableLoading">
    <v-container style="height: 200px;">
      <v-row
        class="fill-height"
        align="center" 
        justify="center"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </v-row>     
    </v-container>
  </div>
  <div
    v-else
    class="mx-3"
  >
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-claims-approval-workflow-dialog-create
          v-if="$hasPermissionTo(['create claim approval workflows']) && approvalWorkflowBatches.length <= 0"
          :employees="employees"
          :departments="departments"
          :positions="positions"
          @created="loadData"
        />
      </v-col>
      <v-spacer />
    </v-row>

    <v-data-table
      :headers="headers"
      :items="approvalWorkflowBatches"
      :loading="tableLoading"
      :search="search"
      show-expand
      :single-expand="true"
      class="remove-box-shadow"
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td 
          :colspan="headers.length" 
          class="py-2 expanded-cell"
          style="background-color: rgba(0, 0, 0, .06);"
        >
          <setup-claims-approval-workflow-expand-view
            :claim-approval-workflow-batch="item"
          />
        </td>
      </template>

      <template v-slot:item.end_date="{ item }">
        {{ item.end_date ? item.end_date : 'N/A' }}
      </template>
      <template v-slot:item.action="{ item }">
        <span
          style="display:inline-block;width:120px"
        >
          <setup-claims-approval-workflow-dialog-edit
            v-if="$hasPermissionTo(['update claim approval workflows']) && item.start_date > $moment().format('YYYY-MM-DD')"
            :approval-workflow-batch="item"
            :employees="employees"
            :departments="departments"
            :positions="positions"
            @updated="loadData"
          />
          <setup-claims-approval-workflow-dialog-delete
            v-if="$hasPermissionTo(['delete claim approval workflows']) && item.start_date > $moment().format('YYYY-MM-DD')"
            :approval-workflow-batch="item"
            @deleted="loadData"
          />
          <setup-claims-approval-workflow-dialog-copy
            v-if="$hasPermissionTo(['create claim approval workflows']) && !item.end_date"
            :approval-workflow-batch="item"
            :employees="employees"
            :departments="departments"
            :positions="positions"
            @updated="loadData"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupClaimsApprovalWorkflowDialogCreate: () => import('@/components/hris/setup/claims/approval-workflow/DialogCreate'),
      SetupClaimsApprovalWorkflowDialogEdit: () => import('@/components/hris/setup/claims/approval-workflow/DialogEdit'),
      SetupClaimsApprovalWorkflowDialogDelete: () => import('@/components/hris/setup/claims/approval-workflow/DialogDelete'),
      SetupClaimsApprovalWorkflowDialogCopy: () => import('@/components/hris/setup/claims/approval-workflow/DialogCopy'),
      SetupClaimsApprovalWorkflowExpandView: () => import('@/components/hris/setup/claims/approval-workflow/ExpandView'),
    },
    data () {
      return {
        approvalWorkflowBatches: [],
        headers: [
          {
            text: 'Total Level of Approval',
            align: 'center',
            value: 'total_level_of_approval',
          },
          {
            text: 'Superior\'s Approval Level',
            align: 'center',
            value: 'superior_approval_level',
          },
          {
            text: 'Start Date',
            align: 'center',
            value: 'start_date',
          },
          {
            text: 'End Date',
            align: 'center',
            value: 'end_date',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        tableLoading: true,
        employees: [],
        positions: [],
        departments: [],
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.tableLoading = true
        
        Promise.all([
          this.$api.claimApprovalWorkflowBatches().list(),
          this.$api.employees().list('?with=active'),
          this.$api.positions().list(),
          this.$api.hrisDepartments().list(['name'], false, true),
        ]).then(([approvalWorkflowBatches, employees, positions, departments]) => {
          this.approvalWorkflowBatches = _.orderBy(approvalWorkflowBatches.data, ['start_date'], ['desc'])
          
          let temp = employees.data.filter(employee => {
            return employee.status === 'complete'
          })
          this.employees = _.orderBy(temp, ['person.name'], ['asc'])

          this.positions = _.orderBy(positions.data, ['name'], ['asc'])

          this.departments = _.orderBy(departments.data, ['name'], ['asc'])

          this.tableLoading = false
        })
      },
      getText (workflow) {
        switch (workflow.approvable_type) {
          case 'App\\Model\\Department':
            return 'Department: '
          case 'App\\Model\\Position':
            return 'Position: '
          case 'App\\Model\\Employee':
            return 'Specific Employee: '
          default:
            return null
        }
      },
    },
  }
</script>

<style scoped>
.remove-box-shadow >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__content{
  box-shadow: unset !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row{
  background-color: rgba(0, 0, 0, .05) !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row .text-start{
  border:0px !important;
}

.remove-box-shadow[border] >>> .v-data-table__wrapper table tbody .v-data-table__expanded.v-data-table__expanded__row .text-left{
  border:0px !important;
}

.expanded-cell {
  max-width: 0;                /* prevent td from expanding table */
  overflow: hidden;
  background-color:  rgba(0, 0, 0, 0.055);
}
</style>
